export default __webpack_public_path__ + "static/media/M24.54441811.svg";